import React from "react";
import { Link, useNavigate } from "react-router-dom";
import BlogLayout from "../components/BlogLayout";
import SEOHead from "../components/SEOHead";
import { getAllPosts } from "../content/blog";
import "./blog.css";

function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function Blog() {
  const navigate = useNavigate();
  const posts = getAllPosts();

  return (
    <BlogLayout>
      <SEOHead
        title="Career Tips & Entry-Level Job Guides"
        description="Expert guides on finding entry-level jobs in California. Tips for first-time job seekers with no experience required."
        path="/blog"
        keywords={[
          "entry level jobs california",
          "career tips",
          "first job advice",
          "no experience jobs",
        ]}
      />

      <div className="blog-list-header">
        <h1>ChapterOne Blog</h1>
        <p>
          Guides and tips for landing your first job in California. No
          experience required.
        </p>
      </div>

      <div className="blog-cards">
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="blog-card"
          >
            <div className="blog-card-date">{formatDate(post.publishedAt)}</div>
            <h2>{post.title}</h2>
            <p>{post.description}</p>
            <span className="blog-card-link">Read article →</span>
          </Link>
        ))}
      </div>

      <div className="blog-cta-banner">
        <h2>Ready to apply?</h2>
        <p>
          Browse entry-level jobs across California — updated daily, no
          experience required.
        </p>
        <button
          type="button"
          className="blog-cta-button"
          onClick={() => navigate("/")}
        >
          Browse Jobs →
        </button>
      </div>
    </BlogLayout>
  );
}

export default Blog;
